import { colorPrimary, colorMain } from "components/styled-components/colors";
import { ContainerTile } from "components/styled-components/generic";
import {
  Mark,
  MarkParagraph,
  TeardropWrapper,
  TemperatureHeader,
  Thumb,
  ThumbLabel,
  Track,
  SliderContainer,
  TeardropValue,
} from "components/styled-components/slider";
import { tempScale } from "constants/temp-scale";
import { getTrackBackground, Range } from "react-range";

const TemperatureSlider = ({
  setTemperature,
  temperature,
}: {
  setTemperature: (p: number[]) => void;
  temperature: number[];
}) => {
  return (
    <ContainerTile>
      <TemperatureHeader>Außentemperatur</TemperatureHeader>
      <SliderContainer>
        <Range
          step={tempScale.step}
          min={tempScale.min}
          max={tempScale.max}
          values={temperature}
          renderMark={({ props, index }) => {
            const everySecondMark = tempScale.marks.filter(
              (_, i) => (i + 1) % 2
            );

            return everySecondMark.includes(tempScale.marks[index]) ? (
              <Mark {...props}>
                <MarkParagraph
                  selectedValue={temperature[0]}
                  value={tempScale.marks[index]}
                >
                  {tempScale.marks[index]} °C
                </MarkParagraph>
              </Mark>
            ) : null;
          }}
          onChange={(values_) => setTemperature(values_)}
          renderTrack={({ props, children }) => (
            <Track
              onMouseDown={props.onMouseDown}
              onTouchStart={props.onTouchStart}
              style={{
                ...props.style,
              }}
            >
              <div
                ref={props.ref}
                style={{
                  height: "5px",
                  width: "100%",
                  borderRadius: "4px",
                  background: getTrackBackground({
                    values: temperature,
                    colors: [colorPrimary, colorMain],
                    min: tempScale.min,
                    max: tempScale.max,
                  }),
                  alignSelf: "center",
                }}
              >
                {children}
              </div>
            </Track>
          )}
          renderThumb={({ props }) => (
            <Thumb {...props}>
              <ThumbLabel>
                <TeardropWrapper>
                  <TeardropValue>{temperature[0]}</TeardropValue>
                </TeardropWrapper>
              </ThumbLabel>
            </Thumb>
          )}
        />
      </SliderContainer>
    </ContainerTile>
  );
};
export default TemperatureSlider;
